namespace $ {

	export class $shm_hitalama_project extends $giper_baza_entity.with({

		Files: $giper_baza_list_link.to( ()=> $shm_hitalama_file ),
		Query_logs: $giper_baza_list_link.to( ()=> $shm_hitalama_project_query_log ),
		Opencode_directory: $giper_baza_atom_text,
		Preview_path: $giper_baza_atom_text,
		Opencode_sessions: $giper_baza_list_str,
		Opencode_session_current: $giper_baza_atom_text,
		Version: $giper_baza_atom_text,
		Version_date: $giper_baza_atom_text,
		Version_changes: $giper_baza_atom_text,
		Version_history: $giper_baza_list_str,

	}){
		
	}

	export class $shm_hitalama_project_query_log extends $giper_baza_entity.with({

		Query: $giper_baza_atom_text,
		Time: $giper_baza_atom_real,

	}){
		
	}

}
